import { render } from "./Prompt.vue?vue&type=template&id=c122426a&scoped=true"
import script from "./Prompt.vue?vue&type=script&lang=js"
export * from "./Prompt.vue?vue&type=script&lang=js"

import "./Prompt.vue?vue&type=style&index=0&id=c122426a&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c122426a"],['__file',"src/components/dialog/Prompt.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "c122426a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('c122426a', __exports__)) {
    api.reload('c122426a', __exports__)
  }
  
  module.hot.accept("./Prompt.vue?vue&type=template&id=c122426a&scoped=true", () => {
    api.rerender('c122426a', render)
  })

}


export default __exports__